import BaseGridScroll from './GridScroll';
import BaseTileWrapper from './Tile';
import { FiEye } from 'react-icons/fi';
import Link from './Link';
import SemanticList from './SemanticList';
import styled from 'styled-components';

const TILE_HEIGHT = '4.125rem';

const Icon = styled(FiEye)`
    font-size: 1.2em;
`;

const TileWrapper = styled(BaseTileWrapper)`
    line-height: 1.145em;
    min-height: ${TILE_HEIGHT};

    ${Icon} {
        color: ${({ theme }) => theme.gray_4};
    }

    &:hover ${Icon} {
        color: inherit;
    }
`;

const Title = styled.span`
    word-break: break-word;
    @media screen and (min-width: ${({ theme }) => theme.bp.sm}px) {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
`;

function Tile({ title, showIcon, ...props }) {
    return (
        <TileWrapper {...props}>
            {!props.isLoading && showIcon ? <Icon /> : null}
            <Title>{title || (props.isLoading ? null : '-')}</Title>
        </TileWrapper>
    );
}

const TILE_WIDTH = 160;

const GridWrap = styled(SemanticList)`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(${TILE_WIDTH}px, 1fr));
    grid-row-gap: ${({ theme }) => theme.space_9}px;
    grid-column-gap: ${({ theme }) => theme.space_9}px;

    & > li {
        display: inline-flex;
    }
`;

const GridScrollPadding = 18;

const GridScroll = styled(BaseGridScroll).attrs(
    ({ padding = GridScrollPadding, paddingTop = 12, gap = 24 }) => ({
        padding,
        paddingTop,
        gap,
    }),
)`
    & > li {
        flex: 0 0 calc(20% - ${({ gap }) => `${gap}px + ${gap}px`} / 5);
    }

    @media screen and (min-width: ${({ theme }) => theme.bp.sm}px) {
        & > li {
            min-width: ${TILE_WIDTH}px;
        }
    }
`;

const Message = styled.div`
    color: ${({ theme }) => theme.gray_2};
    font-weight: 500;
    min-height: ${TILE_HEIGHT};
    display: flex;
    justify-content: center;
    align-items: center;
`;

function LinkTile({
    as = Link,
    mixpanelContext = 'WatchlistTile',
    showIcon = true,
    ...props
}) {
    return (
        <Tile
            as={as}
            mixpanelContext={mixpanelContext}
            showIcon={showIcon}
            {...props}
        />
    );
}

function Tiles({ tiles, status, Grid = GridWrap, Tile = LinkTile, ...props }) {
    if (tiles?.length > 0)
        return (
            <Grid {...props}>
                {tiles.map(({ key, ...tile }) => (
                    <Tile mixpanelContext="WatchlistTile" key={key} {...tile} />
                ))}
            </Grid>
        );
    if (['loading', 'idle'].includes(status))
        return (
            <Grid>
                <Tile as="span" isDisabled={true} isLoading={true} />
            </Grid>
        );
    if (status === 'error') return <Message>Failed to load watchlists</Message>;
    if (tiles?.length < 1)
        return <Message>You haven&#39;t created any watchlists yet</Message>;
    return (
        <Grid>
            <Tile as="span" isDisabled={true} isLoading={false} />
        </Grid>
    );
}

const WatchlistTiles = { Tile, GridWrap, GridScroll, Tiles };

export default WatchlistTiles;
